import { useState } from "react";
import { toast } from "react-toastify";
import { createWatchlist } from "../../api/user";

// Create a new personal list (backend sets parent_id = 4). On success, onDone
// lets the container refetch its lists and close.
export default function CreateListModal({ onClose, onDone }) {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    const trimmed = name.trim();
    if (!trimmed) {
      toast.error("Enter a watchlist name.");
      return;
    }
    setLoading(true);
    try {
      await createWatchlist({ name: trimmed });
      toast.success("Watchlist created");
      onDone?.();
    } catch (err) {
      console.error("Error creating watchlist", err);
      toast.error("Could not create the watchlist. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 px-4">
      <div className="w-full max-w-sm rounded-xl bg-white p-6 shadow-lg">
        <h3 className="mb-4 text-lg font-bold text-[#004d4d]">Create List</h3>
        <input
          type="text"
          value={name}
          autoFocus
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          placeholder="Enter watchlist name"
          className="mb-4 w-full rounded-lg border border-gray-200 px-3 py-2 focus:border-primaryColor focus:outline-none"
        />
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-secondary"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={submit}
            disabled={loading}
            className="rounded-lg bg-primaryColor px-4 py-2 text-sm font-medium text-white disabled:opacity-60"
          >
            {loading ? "Creating..." : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
}
